<template>
    <div class="patient-package-management">
      <!-- <h2 class="page-title">患者套餐管理</h2> -->
      
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="患者姓名">
            <el-input v-model="searchForm.patientName" placeholder="请输入患者姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="患者ID">
            <el-input v-model="searchForm.patientId" placeholder="请输入患者ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属科室">
            <el-select v-model="searchForm.department" placeholder="请选择科室" clearable>
              <el-option label="内科" value="内科"></el-option>
              <el-option label="外科" value="外科"></el-option>
              <el-option label="妇产科" value="妇产科"></el-option>
              <el-option label="儿科" value="儿科"></el-option>
              <el-option label="骨科" value="骨科"></el-option>
              <el-option label="眼科" value="眼科"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="套餐状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="使用中" value="active"></el-option>
              <el-option label="已过期" value="expired"></el-option>
              <el-option label="未启用" value="pending"></el-option>
              <el-option label="已取消" value="canceled"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchPatients">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 患者列表 -->
      <el-card class="patient-list-card">
        <div slot="header" class="card-header">
          <span>患者列表</span>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddPatientDialog">添加套餐</el-button>
        </div>
        
        <el-table
          :data="patientList"
          border
          v-loading="loading"
          style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.packages"
                border
                style="width: 100%">
                <el-table-column prop="packageName" label="套餐名称" width="180"></el-table-column>
                <el-table-column prop="packageType" label="套餐类型" width="120">
                  <template slot-scope="scope">
                    <el-tag :type="getPackageTypeTag(scope.row.packageType)">{{ scope.row.packageType }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="startDate" label="生效日期" width="120"></el-table-column>
                <el-table-column prop="endDate" label="结束日期" width="120"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="getStatusTag(scope.row.status)">
                      {{ getStatusLabel(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="editPackage(props.row, scope.row)">修改</el-button>
                    <el-button
                      size="mini"
                      type="success"
                      plain
                      icon="el-icon-date"
                      @click="extendPackage(props.row, scope.row)"
                      v-if="scope.row.status === 'active'">延期</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      icon="el-icon-delete"
                      @click="cancelPackage(props.row, scope.row)"
                      v-if="scope.row.status === 'active' || scope.row.status === 'pending'">取消</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="patientId" label="患者ID" width="120"></el-table-column>
          <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
          <el-table-column prop="gender" label="性别" width="60"></el-table-column>
          <el-table-column prop="age" label="年龄" width="60"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="department" label="所属科室" width="100"></el-table-column>
          <el-table-column prop="doctor" label="主治医生" width="100"></el-table-column>
          <el-table-column prop="diagnosis" label="诊断信息" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column label="套餐数" width="90">
            <template slot-scope="scope">
              <el-badge :value="scope.row.packages.length" class="package-badge" type="primary">
                <el-button size="mini" type="text">查看明细</el-button>
              </el-badge>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="addPackage(scope.row)">添加套餐</el-button>
              <el-button
                size="mini"
                type="info"
                @click="viewPatientDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </el-card>
      
      <!-- 添加/编辑套餐对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px">
        <el-form :model="packageForm" :rules="packageFormRules" ref="packageForm" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="患者信息">
                <div class="patient-info">
                  <span>{{ currentPatient.patientName }}</span>
                  <span>({{ currentPatient.patientId }})</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主治医生">
                <span>{{ currentPatient.doctor }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="选择套餐" prop="packageId">
            <el-select v-model="packageForm.packageId" placeholder="请选择套餐" style="width: 100%" 
              @change="handlePackageChange">
              <el-option
                v-for="item in packageOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ item.period }}个月 / {{ item.price }}元
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="套餐描述" v-if="selectedPackage">
            <div class="package-description">
              {{ selectedPackage.description }}
            </div>
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生效日期" prop="startDate">
                <el-date-picker
                  v-model="packageForm.startDate"
                  type="date"
                  placeholder="选择开始日期"
                  style="width: 100%"
                  @change="calculateEndDate"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束日期" prop="endDate">
                <el-date-picker
                  v-model="packageForm.endDate"
                  type="date"
                  placeholder="系统自动计算"
                  style="width: 100%"
                  :disabled="!allowEditEndDate"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
                <div class="end-date-tip">
                  <el-checkbox v-model="allowEditEndDate">允许手动修改结束日期</el-checkbox>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="支付方式" prop="paymentMethod">
            <el-select v-model="packageForm.paymentMethod" placeholder="请选择支付方式" style="width: 100%">
              <el-option label="现金支付" value="cash"></el-option>
              <el-option label="医保支付" value="insurance"></el-option>
              <el-option label="微信支付" value="wechat"></el-option>
              <el-option label="支付宝支付" value="alipay"></el-option>
              <el-option label="银行转账" value="bank"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
              v-model="packageForm.remark">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPackageForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 延长套餐对话框 -->
      <el-dialog title="延长套餐有效期" :visible.sync="extendDialogVisible" width="500px">
        <el-form :model="extendForm" ref="extendForm" label-width="100px">
          <el-form-item label="患者信息">
            <div class="patient-info">
              <span>{{ currentPatient.patientName }}</span>
              <span>({{ currentPatient.patientId }})</span>
            </div>
          </el-form-item>
          
          <el-form-item label="套餐名称">
            <span>{{ currentPackage.packageName }}</span>
          </el-form-item>
          
          <el-form-item label="当前结束日期">
            <span>{{ currentPackage.endDate }}</span>
          </el-form-item>
          
          <el-form-item label="延期方式">
            <el-radio-group v-model="extendForm.extendType">
              <el-radio label="days">按天数延期</el-radio>
              <el-radio label="date">指定结束日期</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="延期天数" v-if="extendForm.extendType === 'days'">
            <el-input-number v-model="extendForm.days" :min="1" :max="365"></el-input-number>
            <span class="extend-tip">天</span>
          </el-form-item>
          
          <el-form-item label="新结束日期" v-if="extendForm.extendType === 'date'">
            <el-date-picker
              v-model="extendForm.newEndDate"
              type="date"
              placeholder="选择新的结束日期"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() < new Date(currentPackage.endDate).getTime();
                }
              }"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item label="延期原因">
            <el-select v-model="extendForm.reason" placeholder="请选择延期原因">
              <el-option label="患者申请" value="patient_request"></el-option>
              <el-option label="医生建议" value="doctor_advice"></el-option>
              <el-option label="系统补偿" value="system_compensation"></el-option>
              <el-option label="活动奖励" value="promotion"></el-option>
              <el-option label="其他原因" value="other"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="备注说明" v-if="extendForm.reason === 'other'">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入延期原因"
              v-model="extendForm.remarkText">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="extendDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitExtendForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 患者详情抽屉 -->
      <el-drawer
        title="患者详情"
        :visible.sync="drawerVisible"
        direction="rtl"
        size="50%">
        <div class="drawer-content" v-if="currentPatient">
          <el-descriptions title="基本信息" :column="2" border>
            <el-descriptions-item label="患者姓名">{{ currentPatient.patientName }}</el-descriptions-item>
            <el-descriptions-item label="患者ID">{{ currentPatient.patientId }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ currentPatient.gender }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ currentPatient.age }}岁</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ currentPatient.phone }}</el-descriptions-item>
            <el-descriptions-item label="身份证号">{{ currentPatient.idCard || '-' }}</el-descriptions-item>
            <el-descriptions-item label="所属科室">{{ currentPatient.department }}</el-descriptions-item>
            <el-descriptions-item label="主治医生">{{ currentPatient.doctor }}</el-descriptions-item>
            <el-descriptions-item label="诊断信息" :span="2">{{ currentPatient.diagnosis }}</el-descriptions-item>
          </el-descriptions>
          
          <div class="section-title">套餐记录</div>
          
          <el-timeline>
            <el-timeline-item
              v-for="(pkg, index) in currentPatient.packages"
              :key="index"
              :type="getTimelineItemType(pkg.status)"
              :color="getTimelineItemColor(pkg.status)"
              :timestamp="pkg.startDate + ' 至 ' + pkg.endDate">
              <el-card class="timeline-card">
                <div class="timeline-header">
                  <span class="package-name">{{ pkg.packageName }}</span>
                  <el-tag size="small" :type="getStatusTag(pkg.status)">{{ getStatusLabel(pkg.status) }}</el-tag>
                </div>
                <div class="package-info">
                  <p>
                    <span class="info-label">套餐类型：</span>
                    <el-tag size="small" :type="getPackageTypeTag(pkg.packageType)">{{ pkg.packageType }}</el-tag>
                  </p>
                  <p><span class="info-label">服务项目：</span>{{ pkg.services }}</p>
                  <p><span class="info-label">操作人员：</span>{{ pkg.operator }}</p>
                  <p v-if="pkg.cancelReason"><span class="info-label">取消原因：</span>{{ pkg.cancelReason }}</p>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          
        </div>
      </el-drawer>
      
      <!-- 取消套餐对话框 -->
      <el-dialog title="取消套餐" :visible.sync="cancelDialogVisible" width="500px">
        <el-form :model="cancelForm" ref="cancelForm" label-width="100px" :rules="cancelRules">
          <el-form-item label="患者信息">
            <div class="patient-info">
              <span>{{ currentPatient.patientName }}</span>
              <span>({{ currentPatient.patientId }})</span>
            </div>
          </el-form-item>
          
          <el-form-item label="套餐名称">
            <span>{{ currentPackage.packageName }}</span>
          </el-form-item>
          
          <el-form-item label="起止日期">
            <span>{{ currentPackage.startDate }} 至 {{ currentPackage.endDate }}</span>
          </el-form-item>
          
          <el-form-item label="取消原因" prop="reason">
            <el-select v-model="cancelForm.reason" placeholder="请选择取消原因" style="width: 100%">
              <el-option label="患者申请" value="patient_request"></el-option>
              <el-option label="套餐不匹配" value="package_mismatch"></el-option>
              <el-option label="医生建议" value="doctor_advice"></el-option>
              <el-option label="患者更换套餐" value="package_change"></el-option>
              <el-option label="其他原因" value="other"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="备注说明" prop="remarkText" v-if="cancelForm.reason === 'other'">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入取消原因详情"
              v-model="cancelForm.remarkText">
            </el-input>
          </el-form-item>
          
          <el-form-item label="退费处理">
            <el-radio-group v-model="cancelForm.refundType">
              <el-radio label="no_refund">不退费</el-radio>
              <el-radio label="partial_refund">部分退费</el-radio>
              <el-radio label="full_refund">全额退费</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="退费金额" v-if="cancelForm.refundType !== 'no_refund'">
            <el-input-number 
              v-model="cancelForm.refundAmount"
              :min="0" 
              :max="currentPackage.price || 10000"
              :precision="2"
              :step="100">
            </el-input-number>
            <span class="refund-tip">元</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCancelForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PatientPackageManagement',
    data() {
      return {
        // 搜索表单
        searchForm: {
          patientName: '',
          patientId: '',
          department: '',
          status: ''
        },
        
        // 数据加载状态
        loading: false,
        
        // 分页相关
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        
        // 患者列表数据
        patientList: [],
        
        // 对话框控制
        dialogVisible: false,
        dialogTitle: '添加患者套餐',
        extendDialogVisible: false,
        cancelDialogVisible: false,
        drawerVisible: false,
        
        // 当前操作的患者和套餐
        currentPatient: {},
        currentPackage: {},
        
        // 套餐表单
        packageForm: {
          packageId: '',
          startDate: '',
          endDate: '',
          paymentMethod: '',
          remark: ''
        },
        
        // 表单验证规则
        packageFormRules: {
          packageId: [
            { required: true, message: '请选择套餐', trigger: 'change' }
          ],
          startDate: [
            { required: true, message: '请选择开始日期', trigger: 'change' }
          ],
          endDate: [
            { required: true, message: '结束日期不能为空', trigger: 'change' }
          ],
          paymentMethod: [
            { required: true, message: '请选择支付方式', trigger: 'change' }
          ]
        },
        
        // 延期表单
        extendForm: {
          extendType: 'days',
          days: 30,
          newEndDate: '',
          reason: '',
          remarkText: ''
        },
        
        // 取消表单
        cancelForm: {
          reason: '',
          remarkText: '',
          refundType: 'no_refund',
          refundAmount: 0
        },
        
        // 取消表单验证规则
        cancelRules: {
          reason: [
            { required: true, message: '请选择取消原因', trigger: 'change' }
          ],
          remarkText: [
            { required: true, message: '请输入取消原因详情', trigger: 'blur' }
          ]
        },
        
        // 套餐选项
        packageOptions: [
          {
            id: '1',
            name: '基础随访套餐',
            period: 6,
            price: 1200,
            description: '包含基础随访服务，每月1次电话随访，每季度1次线下随访，提供基础健康咨询。',
            type: '基础套餐'
          },
          {
            id: '2',
            name: '糖尿病专项管理套餐',
            period: 12,
            price: 3600,
            description: '专为糖尿病患者定制，包含血糖定期监测，饮食指导，每月2次专业随访，每季度1次专家会诊。',
            type: '疾病管理'
          },
          {
            id: '3',
            name: '高血压管理套餐',
            period: 12,
            price: 3000,
            description: '针对高血压患者，提供血压监测设备，24小时远程监控，每周健康指导，每月专家评估。',
            type: '疾病管理'
          },
          {
            id: '4',
            name: '老年人关爱套餐',
            period: 12,
            price: 4800,
            description: '专为65岁以上老人设计，包含每周1次电话问候，每月1次上门随访，每季度1次体检，紧急呼叫服务。',
            type: '特需服务'
          },
          {
            id: '5',
            name: '术后康复管理套餐',
            period: 3,
            price: 2400,
            description: '针对手术后患者，包含伤口护理指导，康复训练计划制定，每周2次随访，24小时咨询服务。',
            type: '术后康复'
          },
          {
            id: '6',
            name: '孕产妇关怀套餐',
            period: 15,
            price: 5800,
            description: '覆盖孕期到产后，提供孕期保健指导，营养计划，心理咨询，新生儿护理指导等全方位服务。',
            type: '特需服务'
          },
          {
            id: '7',
            name: '心脏病专项管理套餐',
            period: 12,
            price: 4200,
            description: '针对心脏病患者，提供ECG监测设备，24小时心电监测，每周专家评估，紧急事件处理方案。',
            type: '疾病管理'
          },
          {
            id: '8',
            name: 'VIP全科医疗套餐',
            period: 12,
            price: 8000,
            description: '高端个性化套餐，包含专属医疗团队，优先预约，年度体检，全方位健康管理和咨询服务。',
            type: '高端服务'
          }
        ],
        
        // 当前选中的套餐
        selectedPackage: null,
        
        // 是否允许手动修改结束日期
        allowEditEndDate: false
      }
    },
    created() {
      this.fetchPatientList();
    },
    methods: {
      // 获取患者列表数据
      fetchPatientList() {
        this.loading = true;
        
        // 模拟API请求
        setTimeout(() => {
          // 生成模拟数据
          const mockData = [
            {
              patientId: 'P10001',
              patientName: '许昊然',
              gender: '男',
              age: 45,
              phone: '13812345678',
              idCard: '110101197605134578',
              department: '内科',
              doctor: '李医生',
              diagnosis: '高血压、糖尿病',
              packages: [
                {
                  packageId: '2',
                  packageName: '糖尿病专项管理套餐',
                  packageType: '疾病管理',
                  startDate: '2023-01-15',
                  endDate: '2024-01-14',
                  status: 'active',
                  services: '血糖监测、饮食指导、专家随访',
                  operator: '王护士',
                  price: 3600
                },
                {
                  packageId: '3',
                  packageName: '高血压管理套餐',
                  packageType: '疾病管理',
                  startDate: '2022-08-10',
                  endDate: '2023-08-09',
                  status: 'active',
                  services: '血压监测、健康指导、专家评估',
                  operator: '赵医生',
                  price: 3000
                }
              ]
            },
            {
              patientId: 'P10002',
              patientName: '苏雅婷',
              gender: '男',
              age: 62,
              phone: '13987654321',
              idCard: '110101196105234517',
              department: '心内科',
              doctor: '王医生',
              diagnosis: '冠心病、心律不齐',
              packages: [
                {
                  packageId: '7',
                  packageName: '心脏病专项管理套餐',
                  packageType: '疾病管理',
                  startDate: '2023-03-01',
                  endDate: '2024-02-29',
                  status: 'active',
                  services: 'ECG监测、专家评估、健康管理',
                  operator: '张医生',
                  price: 4200
                }
              ]
            },
            {
              patientId: 'P10003',
              patientName: '林书辰',
              gender: '女',
              age: 35,
              phone: '13765432198',
              idCard: '110101198805136542',
              department: '妇产科',
              doctor: '钱医生',
              diagnosis: '孕期检查',
              packages: [
                {
                  packageId: '6',
                  packageName: '孕产妇关怀套餐',
                  packageType: '特需服务',
                  startDate: '2023-02-10',
                  endDate: '2024-05-09',
                  status: 'active',
                  services: '孕期保健、营养计划、心理咨询',
                  operator: '赵护士',
                  price: 5800
                }
              ]
            },
            {
              patientId: 'P10004',
              patientName: '程若曦',
              gender: '男',
              age: 28,
              phone: '13678901234',
              department: '外科',
              doctor: '钱医生',
              diagnosis: '腰椎间盘突出',
              packages: [
                {
                  packageId: '5',
                  packageName: '术后康复管理套餐',
                  packageType: '术后康复',
                  startDate: '2023-04-15',
                  endDate: '2023-07-14',
                  status: 'active',
                  services: '伤口护理、康复训练、随访服务',
                  operator: '孙医生',
                  price: 2400
                }
              ]
            },
            {
              patientId: 'P10005',
              patientName: '郭子轩',
              gender: '女',
              age: 72,
              phone: '13567890123',
              department: '内科',
              doctor: '孙医生',
              diagnosis: '高血压、关节炎',
              packages: [
                {
                  packageId: '4',
                  packageName: '老年人关爱套餐',
                  packageType: '特需服务',
                  startDate: '2022-12-01',
                  endDate: '2023-11-30',
                  status: 'active',
                  services: '电话问候、上门随访、体检服务',
                  operator: '李护士',
                  price: 4800
                }
              ]
            },
            {
              patientId: 'P10006',
              patientName: '韩宇航',
              gender: '男',
              age: 55,
              phone: '13456789012',
              department: '内科',
              doctor: '刘医生',
              diagnosis: '高血压、高血脂',
              packages: [
                {
                  packageId: '1',
                  packageName: '基础随访套餐',
                  packageType: '基础套餐',
                  startDate: '2022-09-01',
                  endDate: '2023-02-28',
                  status: 'expired',
                  services: '基础随访、健康咨询',
                  operator: '张护士',
                  price: 1200
                },
                {
                  packageId: '3',
                  packageName: '高血压管理套餐',
                  packageType: '疾病管理',
                  startDate: '2023-03-01',
                  endDate: '2024-02-29',
                  status: 'active',
                  services: '血压监测、健康指导、专家评估',
                  operator: '王医生',
                  price: 3000
                }
              ]
            },
            {
              patientId: 'P10007',
              patientName: '江语涵',
              gender: '女',
              age: 40,
              phone: '13345678901',
              department: '外科',
              doctor: '朱医生',
              diagnosis: '乳腺增生',
              packages: []
            },
            {
              patientId: 'P10008',
              patientName: '沈思妍',
              gender: '男',
              age: 68,
              phone: '13234567890',
              department: '神经内科',
              doctor: '周医生',
              diagnosis: '脑梗塞恢复期',
              packages: [
                {
                  packageId: '1',
                  packageName: '基础随访套餐',
                  packageType: '基础套餐',
                  startDate: '2022-11-15',
                  endDate: '2023-05-14',
                  status: 'canceled',
                  services: '基础随访、健康咨询',
                  operator: '李护士',
                  cancelReason: '患者申请更换高级套餐',
                  price: 1200
                },
                {
                  packageId: '8',
                  packageName: 'VIP全科医疗套餐',
                  packageType: '高端服务',
                  startDate: '2022-12-01',
                  endDate: '2023-11-30',
                  status: 'active',
                  services: '专属医疗团队、优先预约、年度体检',
                  operator: '张主任',
                  price: 8000
                }
              ]
            }
          ];
          
          this.pagination.total = mockData.length;
          
          // 进行分页处理
          const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
          const end = start + this.pagination.pageSize;
          this.patientList = mockData.slice(start, end);
          
          this.loading = false;
        }, 800);
      },
      
      // 搜索患者
      searchPatients() {
        this.pagination.currentPage = 1;
        this.fetchPatientList();
      },
      
      // 重置搜索表单
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.searchPatients();
      },
      
      // 分页大小改变
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.fetchPatientList();
      },
      
      // 当前页码改变
      handleCurrentChange(val) {
        this.pagination.currentPage = val;
        this.fetchPatientList();
      },
      
      // 获取套餐类型标签样式
      getPackageTypeTag(type) {
        const typeMap = {
          '基础套餐': '',
          '疾病管理': 'success',
          '特需服务': 'warning',
          '术后康复': 'info',
          '高端服务': 'danger'
        };
        return typeMap[type] || '';
      },
      
      // 获取状态标签样式
      getStatusTag(status) {
        const statusMap = {
          'active': 'success',
          'expired': 'info',
          'pending': 'warning',
          'canceled': 'danger'
        };
        return statusMap[status] || '';
      },
      
      // 获取状态标签文本
      getStatusLabel(status) {
        const statusMap = {
          'active': '使用中',
          'expired': '已过期',
          'pending': '未启用',
          'canceled': '已取消'
        };
        return statusMap[status] || '未知状态';
      },
      
      // 显示添加患者套餐对话框
      showAddPatientDialog() {
        this.dialogTitle = '批量添加患者套餐';
        this.$message({
          message: '请先选择需要添加套餐的患者',
          type: 'info'
        });
      },
      
      // 为特定患者添加套餐
      addPackage(patient) {
        this.dialogTitle = '添加患者套餐';
        this.currentPatient = patient;
        this.packageForm = {
          packageId: '',
          startDate: this.formatDate(new Date()),
          endDate: '',
          paymentMethod: '',
          remark: ''
        };
        this.selectedPackage = null;
        this.dialogVisible = true;
        this.allowEditEndDate = false;
      },
      
      // 编辑套餐
      editPackage(patient, packageItem) {
        this.dialogTitle = '编辑患者套餐';
        this.currentPatient = patient;
        this.currentPackage = packageItem;
        
        // 找到对应的套餐选项
        const packageOption = this.packageOptions.find(p => p.name === packageItem.packageName);
        
        this.packageForm = {
          packageId: packageOption ? packageOption.id : '',
          startDate: packageItem.startDate,
          endDate: packageItem.endDate,
          paymentMethod: 'cash', // 假设当前值
          remark: ''
        };
        
        if (packageOption) {
          this.selectedPackage = packageOption;
        }
        
        this.dialogVisible = true;
        this.allowEditEndDate = false;
      },
      
      // 延长套餐
      extendPackage(patient, packageItem) {
        this.currentPatient = patient;
        this.currentPackage = packageItem;
        
        this.extendForm = {
          extendType: 'days',
          days: 30,
          newEndDate: '',
          reason: '',
          remarkText: ''
        };
        
        this.extendDialogVisible = true;
      },
      
      // 取消套餐
      cancelPackage(patient, packageItem) {
        this.currentPatient = patient;
        this.currentPackage = packageItem;
        
        this.cancelForm = {
          reason: '',
          remarkText: '',
          refundType: 'no_refund',
          refundAmount: 0
        };
        
        this.cancelDialogVisible = true;
      },
      
      // 查看患者详情
      viewPatientDetail(patient) {
        this.currentPatient = patient;
        this.drawerVisible = true;
      },
      
      // 套餐选择变化处理
      handlePackageChange(value) {
        this.selectedPackage = this.packageOptions.find(item => item.id === value);
        this.calculateEndDate();
      },
      
      // 计算结束日期
      calculateEndDate() {
        if (!this.packageForm.startDate || !this.selectedPackage) return;
        
        const startDate = new Date(this.packageForm.startDate);
        const endDate = new Date(startDate);
        
        // 添加套餐时长（月）
        endDate.setMonth(endDate.getMonth() + this.selectedPackage.period);
        // 减去1天，使得结束日期为期限的最后一天
        endDate.setDate(endDate.getDate() - 1);
        
        this.packageForm.endDate = this.formatDate(endDate);
      },
      
      // 提交套餐表单
      submitPackageForm() {
        this.$refs.packageForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API请求
            setTimeout(() => {
              this.$message({
                message: this.dialogTitle === '添加患者套餐' ? 
                  '套餐添加成功！' : '套餐修改成功！',
                type: 'success'
              });
              
              this.dialogVisible = false;
              this.fetchPatientList(); // 重新加载数据
              this.loading = false;
            }, 800);
          }
        });
      },
      
      // 提交延期表单
      submitExtendForm() {
        // 模拟API请求
        this.loading = true;
        
        setTimeout(() => {
          let newEndDate;
          if (this.extendForm.extendType === 'days') {
            const origEndDate = new Date(this.currentPackage.endDate);
            const newDate = new Date(origEndDate);
            newDate.setDate(newDate.getDate() + this.extendForm.days);
            newEndDate = this.formatDate(newDate);
          } else {
            newEndDate = this.extendForm.newEndDate;
          }
          
          this.$message({
            message: `套餐有效期已成功延长至 ${newEndDate}`,
            type: 'success'
          });
          
          this.extendDialogVisible = false;
          this.fetchPatientList(); // 重新加载数据
          this.loading = false;
        }, 800);
      },
      
      // 提交取消表单
      submitCancelForm() {
        this.$refs.cancelForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API请求
            setTimeout(() => {
              const refundText = this.cancelForm.refundType === 'no_refund' ? 
                '不退费' : 
                (this.cancelForm.refundType === 'partial_refund' ? 
                  `部分退费 ${this.cancelForm.refundAmount} 元` : 
                  '全额退费');
              
              this.$message({
                message: `套餐已成功取消，退费处理：${refundText}`,
                type: 'success'
              });
              
              this.cancelDialogVisible = false;
              this.fetchPatientList(); // 重新加载数据
              this.loading = false;
            }, 800);
          }
        });
      },
      
      // 格式化日期为 YYYY-MM-DD
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      
      // 获取时间线项目类型
      getTimelineItemType(status) {
        const typeMap = {
          'active': 'primary',
          'expired': 'info',
          'pending': 'warning',
          'canceled': 'danger'
        };
        return typeMap[status] || 'primary';
      },
      
      // 获取时间线项目颜色
      getTimelineItemColor(status) {
        const colorMap = {
          'active': '#409EFF',
          'expired': '#909399',
          'pending': '#E6A23C',
          'canceled': '#F56C6C'
        };
        return colorMap[status] || '#409EFF';
      }
    }
  }
  </script>
  
  <style scoped>
  .patient-package-management {
    padding: 20px;
  }
  
  .page-title {
    margin-bottom: 20px;
    font-weight: 500;
    color: #303133;
  }
  
  .search-card {
    margin-bottom: 20px;
  }
  
  .patient-list-card {
    margin-bottom: 20px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .patient-info {
    display: flex;
    align-items: center;
  }
  
  .patient-info span:first-child {
    font-weight: bold;
    margin-right: 10px;
  }
  
  .patient-info span:last-child {
    color: #909399;
  }
  
  .package-description {
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 10px;
    color: #606266;
    line-height: 1.5;
  }
  
  .end-date-tip {
    margin-top: 5px;
    color: #909399;
    font-size: 12px;
  }
  
  .extend-tip, .refund-tip {
    margin-left: 5px;
    color: #606266;
  }
  
  .drawer-content {
    padding: 20px;
  }
  
  .section-title {
    font-size: 16px;
    font-weight: 500;
    margin: 20px 0 10px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
  }
  
  .timeline-card {
    margin-bottom: 10px;
  }
  
  .timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .package-name {
    font-weight: bold;
    color: #303133;
  }
  
  .package-info {
    color: #606266;
    line-height: 1.5;
  }
  
  .info-label {
    color: #909399;
    margin-right: 5px;
  }
  
  /* 覆盖 Element UI 的某些样式 */
  :deep(.el-table__expanded-cell) {
    padding: 15px;
  }
  
  .package-badge :deep(.el-badge__content) {
    background-color: #409EFF;
  }
  </style>